export default "Perché\nQuanti\ncome"